export const isInvalidZipCode = (zipCode: string | undefined, country: string | undefined) => {
  if (!country) {
    return false;
  }

  if (!zipCode || zipCode.length === 0) {
    return false;
  }

  if (country === "Deutschland" || country === "Frankreich" || country === "Italien") {
    let isValid = /^(\d){5}$/.test(zipCode);
    if (!isValid) {
      return true;
    }
  }

  if (country === "Schweiz" || country === "Österreich" || country === "Liechtenstein") {
    let isValid = /^(\d){4}$/.test(zipCode);
    if (!isValid) {
      return true;
    }
  }
};
